module.exports = __webpack_public_path__ + "img/crm_elec_solution_bg.e84f4db8.png";